var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'TRC-Banner': 1,
        'TRC-Banner--dismissed': _vm.dismissed,
    }},[_c('div',{staticClass:"TRC-Banner__Header"},[_c('div',{staticClass:"TRC-Banner__Title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closable)?_c('div',{staticClass:"TRC-Banner__CloseButton",on:{"click":_vm.close}},[_vm._v("\n            ✕\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"TRC-Banner__Content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }